const carouselItems = [
  {
    title: '热血战斗专题',
    subtitle: '燃烧吧！最燃战斗漫画合集',
    desc: '汇集《鬼灭之刃》《咒术回战》《我的英雄学院》等热血战斗漫画，每一页都让你肾上腺素飙升。',
    count: '收录326部',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20action%20manga%20style%20illustration%20with%20dynamic%20battle%20scene%2C%20two%20warriors%20clashing%20with%20energy%20effects%2C%20fiery%20background%20with%20sparks%20and%20smoke%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20composition%2C%20intense%20atmosphere&width=800&height=450&seq=carousel-comic-01&orientation=landscape',
  },
  {
    title: '恋爱甜宠专题',
    subtitle: '甜甜的恋爱漫画一次看够',
    desc: '从校园初恋到职场恋爱，最甜的恋爱漫画都在这里。怦然心动的瞬间，陪你度过每一个温暖的午后。',
    count: '收录289部',
    image: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20manga%20illustration%20of%20a%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20spring%2C%20school%20uniforms%2C%20blushing%20expressions%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20gentle%20sunlight%20filtering%20through%20petals%2C%20dreamy%20atmosphere&width=800&height=450&seq=carousel-comic-02&orientation=landscape',
  },
  {
    title: '异世界转生专题',
    subtitle: '从零开始的异世界冒险',
    desc: '穿越到异世界成为最强？这里有你喜欢的各种异世界转生漫画，从冒险到种田，总有一款适合你。',
    count: '收录412部',
    image: 'https://readdy.ai/api/search-image?query=A%20fantasy%20isekai%20manga%20illustration%20showing%20a%20magical%20otherworld%20landscape%20with%20floating%20islands%2C%20a%20character%20in%20adventurer%20garb%20standing%20at%20a%20portal%20gate%2C%20magical%20runes%20glowing%2C%20vibrant%20greens%20and%20golden%20tones%2C%20epic%20fantasy%20style&width=800&height=450&seq=carousel-comic-03&orientation=landscape',
  },
  {
    title: '悬疑推理专题',
    subtitle: '烧脑推理漫画精选集',
    desc: '真相只有一个！最扣人心弦的悬疑推理漫画，层层反转让你欲罢不能，考验你的推理能力和洞察力。',
    count: '收录198部',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20manga%20illustration%20with%20a%20shadowy%20figure%20in%20a%20trench%20coat%20standing%20in%20a%20foggy%20alleyway%20at%20night%2C%20clues%20scattered%20on%20the%20ground%2C%20a%20magnifying%20glass%2C%20dark%20purple%20and%20teal%20tones%2C%20noir%20atmosphere%2C%20intriguing%20composition&width=800&height=450&seq=carousel-comic-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            精选专题合集，发现你的下一部入坑之作
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
            {carouselItems.map((item) => (
              <div
                key={item.title}
                className="group relative bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <span className="text-xs text-white/90 bg-primary-500 px-2.5 py-1 rounded-full">
                      {item.count}
                    </span>
                    <h3 className="mt-2 font-heading text-lg text-white">{item.title}</h3>
                    <p className="mt-1 text-sm text-white/80">{item.subtitle}</p>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}